/** Interface that can be used to generically type a class. */
export type ComponentType<T> = new (...args: any[]) => T;
